export enum DuplexerEvent {
  FileStatusUpdate = 'status_update',
  TrashFoldersRestoreCompleted = 'trash_folders_restore_completed',
  TrashFilesRestoreCompleted = 'trash_files_restore_completed',
  CopyFolder = 'copy_folder',
  CopyFile = 'copy_file',
  TrashEmpty = 'trash_empty',
  OutputStatusUpdate = 'output_status_update',
  StorageUsageUpdate = 'site_usage_update',
  PremiumPlanChanged = 'site_premium_plan_changed',
}
